import React, { useState, useEffect } from "react";
import styled from "styled-components";
import DesktopSlider from "./DesktopSlider";
import { getMobileQuery } from "../common/utils";
import { motion } from "framer-motion";
import SingleBookPreview from "../library/SingleBookPreview";
import MobileSlider from "./MobileSlider";
import { useLocation, useNavigate } from "react-router-dom";
import { addOrDeleteQueryParams } from "../common/queryHandler";

const WrapperStyled = styled.div``;

const BookList = ({ list, lang, langData, config }) => {
    const location = useLocation();
    const navigate = useNavigate();
    const searchParams = new URLSearchParams(location.search);
    const templateId = searchParams.get("templateId");

    const [bookPreview, s_bookPreview] = useState(null);
    const [lastSeen, s_lastSeen] = useState(null);
    const [lastPage, s_lastPage] = useState(0);
    const [visibleItemIndex, setVisibleItemIndex] = useState(0);
    const innerWidth = getMobileQuery();
    const isMobile = innerWidth < 550;

    useEffect(() => {
        if (templateId) {
            const currentBook = list.find((template) => template._id === templateId);
            s_bookPreview(currentBook);
            s_lastSeen(currentBook);
        }
    }, [location.search]);

    const changeUrl = (query) => {
        navigate({
            search: query
        });
    };

    const itemVariants = {
        initial: { opacity: 0, scale: 0 },
        animate: { opacity: 1, scale: 1 }
    };
    const getItemAnimation = (delay, isBg) => ({
        initial: "initial",
        animate: "animate",
        variants: itemVariants,
        transition: { duration: 0.4, delay }
    });

    let maxInRow = 3;

    if (innerWidth < 1000) {
        maxInRow = 2;
    }

    if (innerWidth < 480) {
        maxInRow = 1;
    }

    return (
        <WrapperStyled>
            { !bookPreview && !templateId && (
                <>
                    { !isMobile && (
                        <DesktopSlider
                            lastSeen={ lastSeen }
                            lastPage={ lastPage }
                            s_lastPage={ s_lastPage }
                            config={ config }
                            items={ list }
                            lang={ lang }
                            langData={ langData }
                            maxRows={ 2 }
                            maxInRow={ maxInRow }
                            getItemAnimation={ getItemAnimation }
                            bookPreviewHandle={ (book) => {
                                s_bookPreview(book);
                                s_lastSeen(book);
                            }
                            }
                        />
                    ) }
                    { isMobile && (
                        <MobileSlider
                            lastSeen={ lastSeen }
                            config={ config }
                            items={ list }
                            lang={ lang }
                            langData={ langData }
                            maxRows={ 2 }
                            maxInRow={ maxInRow }
                            visibleItemIndex={ visibleItemIndex }
                            setVisibleItemIndex={ setVisibleItemIndex }
                            getItemAnimation={ getItemAnimation }
                            bookPreviewHandle={ (book) => {
                                s_bookPreview(book);
                                s_lastSeen(book);
                            }
                            }
                        />
                    ) }
                </>
            ) }

            { bookPreview && (
                <motion.div { ...getItemAnimation(0.2, true) }>
                    <SingleBookPreview
                        config={ config }
                        selecteBook={ () => {
                            const urlToPush = addOrDeleteQueryParams(location, [{ templateId: null }]);
                            changeUrl(urlToPush);
                            s_bookPreview(null);
                        } }
                        item={ bookPreview }
                        lang={ lang }
                        langData={ langData }
                        disableBackButton={ !!templateId }
                    />
                </motion.div>
            ) }
        </WrapperStyled>
    );
};

export default BookList;
